/**
 * A general deprecated console warning avoided by lint
 */
export default (message) => {
    // eslint-disable-next-line
    console.warn(message);
};
//# sourceMappingURL=deprecatedWarning.js.map